import React from 'react';
import Dropdown from '../components/Dropdown';
import DropdownInput from '../components/DropdownInput';
import DropdownRange from '../components/DropdownRange';
import Header from '../components/Header';
import Button from '../components/Button';
import Card from '../components/Card';
import { CircularProgress } from '@material-ui/core';
import { parse } from 'date-fns'

import { ArchieveData, FilterArchive } from '../models/card';

interface HomeState {
    totalData: ArchieveData[]
    displayedData: ArchieveData[]
    filter: FilterArchive;
    isLoading: boolean;
}

class Home extends React.PureComponent<any, HomeState>{
    constructor(props: any) {
        super(props);
        this.state = {
            totalData: [],
            displayedData: [new ArchieveData()],
            filter: new FilterArchive(),
            isLoading: true,
        };
        this.setFilter = this.setFilter.bind(this);
        this.filterProcess = this.filterProcess.bind(this);
    }

    componentDidMount() {
        const temp: ArchieveData[] = [];
        this.setState({ displayedData: temp })
        const query = this.props.firebase.database().ref('archieve');
        query.on('value', (data: any) => {
            const totalData: ArchieveData[] = data.val();
            const filteredData = this.filterProcess(this.state.filter, totalData);
            this.setState({ totalData: totalData, displayedData: filteredData, isLoading: false });
        }, (err: any) => { 
            this.props.history.push('/NOT_FOUND');
        });
    }

    componentWillUnmount(){
    }

    setFilter(updatedFilter: FilterArchive, type: string) {
        const filter: FilterArchive = { ...this.state.filter };
        if (type === 'date') {
            filter.startDate = updatedFilter.startDate;
            filter.endDate = updatedFilter.endDate;
        }
        if (type === 'noOfTweets') {
            filter.noOfTweetsStart = updatedFilter.noOfTweetsStart;
            filter.noOfTweetsEnd = updatedFilter.noOfTweetsEnd;
        }
        if (type === 'sortBy') {
            filter.sortBy = updatedFilter.sortBy;
        }
        if (type === 'categories') {
            filter.categories = updatedFilter.categories;
        }
        this.setState({ filter: filter });
        const filteredData = this.filterProcess(filter, this.state.totalData);
        this.setState({ displayedData: filteredData });
    }

    filterProcess(filter: FilterArchive, totalData: ArchieveData[]) {
        let filterData = [...totalData];
        const map = new Map();
        // category
        filter.categories?.forEach((category: any) => {
            map.set(category.value, category.value);
        });
        if (map.size > 0) {
            filterData = filterData.filter(data => {
                return data.categories?.find(category => map.has(category)) !== undefined;
            })
        }
        // range
        filterData = filterData.filter(data => (data.noOfTweets >= filter.noOfTweetsStart) && (data.noOfTweets <= filter.noOfTweetsEnd));
        // date
        const filterStart = parse(filter.startDate, 'dd/MM/yyyy', new Date());
        const filterStop = parse(filter.endDate, 'dd/MM/yyyy', new Date());
        filterData = filterData.filter(data => {
            const date = parse(data.date, 'dd/MM/yyyy', new Date());
            if (date >= filterStart && date <= filterStop) {
                return true;
            }
            return false;
        });
        // sortBy
        if (filter.sortBy === 'Submitted Date') {
            filterData.sort(function (a, b) {
                if (a && b) {
                    const dateA = parse(a.date, 'dd/MM/yyyy', new Date());
                    const dateB = parse(b.date, 'dd/MM/yyyy', new Date());
                    if (dateA > dateB) return -1;
                    if (dateA < dateB) return 1;
                }
                return 0;
            });
        }
        if (filter.sortBy === 'Latest Activity') {
            filterData.sort();
            filterData.reverse();
        }
        if (filter.sortBy === 'Topic Name') {
            filterData.sort(function (a, b) {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();
                return nameA.localeCompare(nameB);
            });
        }
        if (filter.sortBy === 'Volume') {
            filterData.sort(function (a, b) {
                if (a.noOfTweets > b.noOfTweets) return -1;
                if (a.noOfTweets < b.noOfTweets) return 1;
                return 0;
            });
        }
        return filterData;
    }

    render() {
        const { displayedData, filter, isLoading } = this.state;
        if (isLoading) {
            return (
                <React.Fragment>
                    <Header className={'m-0'} />
                    <div className='container-center' style={{ margin: '40px' }}>
                        <CircularProgress color={"primary"} style={{ color: '#fcd745' }} size={120} thickness={2.0} />
                    </div>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <Header />
                <div className="row" style={{ marginBottom: '20px' }}>
                    <div className="col-sm-4 col-md-4">
                        <Button text={'+New Topic'} className={'col-md-4 col-sm-6 btn-input width-200'} onClickBtn={() => {this.props.history.push('/archieve')}}/>
                    </div>
                    <div className="col-sm-8 col-md-8 ">
                        <div className="float-right">
                            <div className="row">
                                <DropdownInput className={'col-md-4 col-sm-12 btn-input width-250'} setFilter={this.setFilter} filter={filter} />
                                <DropdownRange className={'col-md-4 col-sm-12 btn-input width-250'} setFilter={this.setFilter} filter={filter} />
                                <Dropdown className={'col-md-4 col-sm-12 btn-input width-250'} setFilter={this.setFilter} filter={filter} />
                            </div>
                        </div>
                    </div>
                </div>
                {
                    displayedData.map((data: ArchieveData, index: number) => {
                        if (index % 3 === 0) {
                            return (
                                <div key={`h-${data.id}`} className="row">
                                    <div className="col-md-4 col-sm-12">
                                        {displayedData[index] && <Card className="container-center" onClick={() => { this.props.history.push(`/archieve/${displayedData[index].id}`) }} key={`d-${displayedData[index].id}`} archieve={displayedData[index]} />}
                                    </div>
                                    <div className="col-md-4 col-sm-12">
                                        {displayedData[index + 1] && <Card className="container-center" onClick={() => { this.props.history.push(`/archieve/${displayedData[index + 1].id}`) }} key={`d-${displayedData[index+1].id}`} archieve={displayedData[index + 1]} />}
                                    </div>
                                    <div className="col-md-4 col-sm-12">
                                        {displayedData[index + 2] && <Card className="container-center" onClick={() => { this.props.history.push(`/archieve/${displayedData[index + 2].id}`) }} key={`d-${displayedData[index+2].id}`} archieve={displayedData[index + 2]} />}
                                    </div>
                                </div>
                            );
                        } else {
                            return null
                        }
                    })
                }
            </React.Fragment>
        );
    }
}

export default Home;